import { render, staticRenderFns } from "./TemplatePageP4.vue?vue&type=template&id=47652f5b&"
import script from "./TemplatePageP4.vue?vue&type=script&lang=js&"
export * from "./TemplatePageP4.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePageP4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports